/* @flow */
import gql from 'graphql-tag';
import React from 'react';
import ExpandedGroup, {
    fragments as expandedGroupFragments
} from './ExpandedGroup';

import type {Shape as ExpandedGroupShape} from './ExpandedGroup';
import type {MouseLeaveShape} from '../Hit/Hit';

import './ExpandedGroups.less';

export type Shape = ExpandedGroupShape[];

export const fragments = {
    searchResult: gql`
        fragment ExpandedGroupsSearchResult on SearchResult {
            expandedGroups {
                ...ExpandedGroupExpandedGroup
            }
        }
        ${expandedGroupFragments.expandedGroup}
    `
};

type Props = {
    expandedGroups: Shape,
    onHitMouseEnter: (string) => void,
    onHitMouseLeave: (MouseLeaveShape) => void,
    page?: number,
    pageSize?: number
};

export default function ExpandedGroups({
    onHitMouseEnter,
    onHitMouseLeave,
    expandedGroups,
    page,
    pageSize
}: Props) {
    return (
        <dl className="ExpandedSearchGroups">
            {expandedGroups.map((expandedGroup, i) => (
                <ExpandedGroup
                    key={i}
                    index={i}
                    onHitMouseEnter={onHitMouseEnter}
                    onHitMouseLeave={onHitMouseLeave}
                    expandedGroup={expandedGroup}
                    page={page}
                    pageSize={pageSize}
                />
            ))}
        </dl>
    );
}
